<!--
 * @Author: M.D.
 * @Date: 2019-12-17 16:50:25
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="user-info bShadow-5">
    <el-tabs value="gr" class="ui-tabs ui-custom-s">
      <el-tab-pane name="gr">
        <span slot="label" class="lb-txt"> 个人信息 </span>

        <!-- 表单 -->
        <div class="ui-form-wrapper">
          <el-form
            ref="form"
            :model="form"
            label-position="right"
            label-width="130px"
          >
            <!-- 1 -->
            <el-row>
              <el-col :span="10">
                <el-form-item label="用户名" prop="username">
                  <el-input v-model="form.username"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <div class="grid-content bg-purple-light">
                  <el-form-item
                    label="手机号"
                    prop="mobile"
                    :rules="rule.phone"
                    @click.native="onchangePhone"
                  >
                    <el-input v-model="form.mobile" readOnly></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <!-- 2   @change="handleChange"-->
            <el-row>
              <!-- <el-col :span="10">
                <el-form-item
                  label="所在地区"
                  prop="region"
                  :rules="rule.region"
                >
                  <el-cascader
                    style="width: 100%"
                    :disabled="!canAlertRegion"
                    v-model="form.region"
                    :options="options"
                    :props="{ checkStrictly: true }"
                    @change="handleChange"
                  ></el-cascader>
                </el-form-item>
              </el-col> -->
              <el-col :span="10">
                <el-form-item
                  label="税控盘号"
                  prop="taxControlPanelNumber"
                  :rules="rule.word20"
                >
                  <el-input
                    :disabled="!infoEditable"
                    v-model="form.taxControlPanelNumber"
                  ></el-input>
                </el-form-item>
                <!-- <div class="grid-content bg-purple-light">
                  <el-form-item label="性别">
                    <el-radio-group v-model="form.gender">
                      <el-radio :label="0">男</el-radio>
                      <el-radio :label="1">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div> -->
              </el-col>

              <el-col :span="10" :offset="2">
                <el-form-item
                  label="税务机关代码"
                  prop="taxAuthCode"
                  :rules="rule.word12"
                >
                  <el-input
                    :disabled="!infoEditable"
                    v-model="form.taxAuthCode"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 3 -->
            <el-row>
              <!-- <el-col :span="10">
                <el-form-item label="所属行业" prop="occupation">
                  <el-select
                    style="width: 100%"
                    v-model="form.occupation"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in occupationOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->

              <el-col :span="10" :offset="2" v-show="false">
                <el-form-item
                  prop="taxpayerNo"
                  label="纳税人识别号"
                  :rules="rule.word20"
                >
                  <el-input
                    :disabled="!infoEditable"
                    v-model="form.taxpayerNo"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <!-- <el-form-item
                  label="纳税人名称"
                  prop="taxCtrlUsrName"
                  :rules="rule.word100"
                >
                  <el-input v-model="form.taxCtrlUsrName"></el-input>
                </el-form-item> -->
              </el-col>
            </el-row>

            <!-- 5 -->
            <el-row>
              <el-col :span="22">
                <el-form-item
                  label="详细地址"
                  prop="address"
                  :rules="rule.word100"
                >
                  <el-input
                    v-model="form.address"
                    type="textarea"
                    resize="none"
                    :autosize="false"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 全电信息 -->
            <div class="tishi">
              <el-checkbox
                v-model="zclx"
                true-label="2"
                false-label="1"
                :disabled="cancancel"
                @change="czlxchange"
                >全电发票</el-checkbox
              >
              <el-button
                @click="downloadfile"
                type="text"
                style="margin-left:20px"
                >全电发票控件下载</el-button
              >
            </div>

            <el-row>
              <el-col :span="10">
                <el-form-item
                  label="社会信用代码"
                  prop="socialCreditNo"
                  :rules="zclx == 2 ? qdrule.kpdwdm : [{ required: false }]"
                >
                  <el-input
                    :disabled="creditCodeDisabled"
                    v-model="form.socialCreditNo"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item
                  label="纳税人名称"
                  prop="taxCtrlUsrName"
                  :rules="zclx == 2 ? qdrule.kpdwmc : [{ required: false }]"
                >
                  <el-input v-model="form.taxCtrlUsrName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="10">
                <el-form-item
                  label="电子税务局账号"
                  prop="dzswjzh"
                  :rules="zclx == 2 ? qdrule.dzswjzh : [{ required: false }]"
                >
                  <el-input
                    v-model="form.dzswjzh"
                    :disabled="zclx == 1"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item
                  label="电子税务局密码"
                  prop="dzswjmm"
                  :rules="zclx == 2 ? qdrule.dzswjmm : [{ required: false }]"
                >
                  <el-input
                    v-model="form.dzswjmm"
                    :disabled="zclx == 1"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="myfrom">
              <el-button
                class="btn"
                type="primary"
                :loading="loading"
                @click="onSubmit"
                >保存修改</el-button
              >
            </div>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog ref="phoneDialog" :visible.sync="phoneDialogShow" width="500px">
      <div slot="title">验证手机号</div>
      <el-form
        ref="phoneForm"
        :model="phoneForm"
        label-position="right"
        label-width="100px"
      >
        <el-row :gutter="20">
          <div class="tp-f-item">
            <el-form-item
              label="手机号码"
              class="u-pwd-phone"
              prop="phone"
              :rules="rule.phone"
            >
              <el-input
                placeholder="请输入手机号码"
                v-model="phoneForm.phone"
              ></el-input>
            </el-form-item>
          </div>
        </el-row>

        <el-row :gutter="20">
          <div class="tp-f-item">
            <el-form-item
              label="验证码"
              class="u-pwd-auth-c"
              prop="authCode"
              :rules="rule.required"
            >
              <auth-code
                :phoneNum="phoneForm.phone"
                @authCodeChange="setNewAuthCode"
              ></auth-code>
            </el-form-item>
          </div>
        </el-row>
        <el-row :gutter="20">
          <div style="text-align: center">
            <el-button
              type="primary"
              :loading="phoneLoading"
              @click="onSendPhoneChangeReq"
              >保存修改</el-button
            >
          </div>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { areaData, getAreaTxt } from '@/util/area'
import API from '@/api/usr-api'
import { mapActions, mapGetters } from 'vuex'
import rule from '@/util/rule'
import AuthCode from '@/components/auth-code'

export default {
  name: 'userInfo',
  props: {},
  data() {
    return {
      zclx: '1',
      cancancel: false,
      qdrule: {
        kpdwdm: [
          {
            required: true,
            message: '请输入社会信用代码',
            trigger: 'blur',
          },
          {
            min: 15,
            max: 20,
            message: '长度在 15 到 20 个字符',
            trigger: 'blur',
          },
        ],
        kpdwmc: [
          {
            required: true,
            message: '请输入纳税人名称',
            trigger: 'blur',
          },
        ],

        dzswjzh: [
          {
            required: true,
            message: '请输入电子税务局账号',
            trigger: 'blur',
          },
        ],
        dzswjmm: [
          {
            required: true,
            message: '请输入电子税务局密码',
            trigger: 'blur',
          },
        ],
      },
      occupationOptions: [],
      phoneForm: {
        phone: '',
        authCode: '',
      },
      phoneDialogShow: false,
      rule,
      phoneLoading: false,
      loading: false,
      form: {
        username: '',
        mobile: '',
        gender: -1,
        taxControlPanelNumber: '', // 税控设备号
        address: '',
        occupation: '',
        taxpayerNo: '',
        taxAuthCode: '',
        socialCreditNo: '',
        taxCtrlUsrName: '',
        areaCode: '',
        region: [],
        dzswjmm: '',
        dzswjzh: '',
      },
      creditCodeDisabled: false,
      // 地区选择
      options: areaData,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    infoEditable() {
      return this.userInfo && this.userInfo.source !== 2
    },
    canAlertRegion: function() {
      /*      if (this.userInfo.source === 1) {
        return this.userInfo.modifyNum > 0
      } else if (this.userInfo.source === 2) {
        return false
      }
      return false*/ //lyj
      return this.userInfo.modifyNum > 0
    },
  },
  created() {
    console.log(this.userInfo)
    if (this.userInfo.dzswjzh) {
      this.zclx = '2'
      this.cancancel = true
    }
    if (this.$route.query.op) {
      this.zclx = '2'
      this.cancancel = true
    }
  },
  mounted() {},
  activated() {
    this.initData()
    this.getDitType()
    // this.$store.dispatch('getMemberInfo')
  },
  deactivated() {},
  watch: {},
  methods: {
    ...mapActions(['setUserInfo']),
    downloadfile() {
      let n = Math.ceil(Math.random() * 10)
      let address =
        'https://www.chinaqjwx.cn/jsyw/File_down.interface?type=chromeReq.rar&tm=' +
        n
      let time = new Date().getTime()
      let val = address + '&time=' + time

      // window.open(val)
      window.location.href = val
    },
    async getDitType() {
      const res = await API.getDitType()
      if (res.data.statusCode === '200') {
        this.occupationOptions = []
        for (const item of res.data.result) {
          this.occupationOptions.push({
            value: item.code,
            label: item.name,
          })
        }
      }
    },
    async onSendPhoneChangeReq() {
      this.$refs.phoneForm.validate(async valid => {
        if (valid) {
          this.phoneLoading = true
          const res = await API.updateUserInfo({
            id: this.userInfo.id,
            mobile: this.phoneForm.phone,
            code: this.phoneForm.authCode,
          })
          this.phoneLoading = false
          if (res.data.statusCode === '200') {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.$store.dispatch('getMemberInfo')
            this.setUserInfo(res.data.result)
            this.initData()
            this.phoneDialogShow = false
          } else {
            this.$message({
              message: res.data.message,
              type: 'warning',
            })
          }
        }
      })
    },
    onchangePhone() {
      this.phoneDialogShow = true
    },
    // 获取AuthCode
    setNewAuthCode(newVal) {
      this.phoneForm.authCode = newVal
    },
    initData() {
      console.log(this.userInfo)
      this.form.id = this.userInfo.id
      this.form.username = this.userInfo.username
      this.form.mobile = this.userInfo.mobile
      this.form.gender = this.userInfo.gender
      this.form.taxControlPanelNumber = this.userInfo.taxControlPanelNumber
      this.form.address = this.userInfo.address
      this.form.areaCode = this.userInfo.areaCode
      //没用地区默认一个地区为武侯区
      if (!this.form.areaCode) {
        this.form.areaCode = '510107'
      }
      this.form.cityCode = this.userInfo.cityCode
      this.form.socialCreditNo = this.userInfo.creditCode
      this.form.provinceCode = this.userInfo.provinceCode
      this.form.taxAuthCode = this.userInfo.taxAuthorityCode
      this.form.taxControlPanelNumber = this.userInfo.taxControlPanelNumber
      this.form.taxCtrlUsrName = this.userInfo.taxpayerName
      this.form.taxpayerNo = this.userInfo.taxpayerNumber
      this.form.occupation = this.userInfo.trade

      // if (this.userInfo.gbQdyh) {
      //   this.form.dzswjzh = this.userInfo.gbQdyh.dzswjzh
      //   this.form.dzswjmm = this.userInfo.gbQdyh.dzswjmm
      // } else {
      //   this.form.dzswjzh = ''
      //   this.form.dzswjmm = ''
      // }
      this.form.dzswjzh = this.userInfo.dzswjzh || ''
      this.form.dzswjmm = this.userInfo.dzswjmm || ''

      this.form.region = [
        this.userInfo.provinceCode,
        this.userInfo.cityCode,
        this.userInfo.areaCode,
      ]
      this.creditCodeDisabled = this.userInfo.creditCode.length > 0
      //console.log("creditCodeDisabled:")
      //console.log(creditCodeDisabled)
    },
    async onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          //alert(this.form.region+getAreaTxt(this.form.region))
          let regionstr = getAreaTxt(this.form.region) //代码转成文字
          this.loading = true

          let requestdata = {
            id: this.userInfo.id,
            address: this.form.address,
            areaCode: this.form.areaCode,
            cityCode: this.form.cityCode,
            creditCode: this.form.socialCreditNo,
            mobile: this.form.mobile,
            provinceCode: this.form.provinceCode,
            //region: this.form.region,
            region: regionstr,
            taxAuthorityCode: this.form.taxAuthCode,
            taxControlPanelNumber: this.form.taxControlPanelNumber,
            taxpayerName: this.form.taxCtrlUsrName,
            taxpayerNumber: this.form.taxpayerNo,
            trade: this.form.occupation,
            username: this.form.username,
          }
          requestdata.memberDto = {}
          requestdata.memberDto.zclx = this.zclx
          if (this.zclx == 2) {
            requestdata.memberDto.dzswjzh = this.form.dzswjzh
            requestdata.memberDto.dzswjmm = this.form.dzswjmm
          }

          const res = await API.updateUserInfo(requestdata)
          this.loading = false
          if (res.data.statusCode === '200') {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            let database = res.data.result
            if (this.zclx == 2) {
              database.gbQdyh = {}
              database.gbQdyh.dzswjzh = this.form.dzswjzh
              database.gbQdyh.dzswjmm = this.form.dzswjmm
            }
            console.log(database, 'database')

            this.setUserInfo(database)
            this.initData()
            // 获取跳转过来的路由名字
            let saveOrderConfirm = sessionStorage.getItem('orderConfirmName')
            let saveorderConfirmFullPath = sessionStorage.getItem(
              'orderConfirmFullPath',
            )
            // 判断路由路由名字是否需要跳转
            if (saveOrderConfirm === 'orderConfirm') {
              this.$router.push(`${saveorderConfirmFullPath}`)
            }
            if (this.$route.query.op) {
              this.$emit('openPay')
              //调用一键登录进入全电
            }
          } else {
            this.$message(res.data.message)
          }
        }
      })
    },

    handleChange(ids) {
      this.$refs.form.validateField('region') // 验证地区
      this.form.provinceCode = ids[0]
      this.form.cityCode = ids[1]
      this.form.areaCode = ids[2]
    },
    czlxchange() {
      if (this.zclx == 2) {
        this.$confirm('开通全电服务, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {})
          .catch(() => {
            this.zclx = '1'
          })
      }
    },
  },
  components: {
    AuthCode,
  },
}
</script>

<style lang="stylus" scoped>
.user-info {
  width:1030px;
  height: 666px;
  box-sizing: border-box;
  background-color: #ffffff;
  overflow: hidden;
  .myfrom{
    width:100%;
    display:flex;
    justify-content: center;

  }

  .lb-txt {
    font-family: AdobeHeitiStd-Regular;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
  }


  .ui-form-wrapper {
    // height 580px
    box-sizing: border-box;
    padding: 40px;

    .btn {
      margin-top: 30px;
    }
  }
}
</style>
